// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"8037ac84","239":"ad40150f","576":"e52692ff","833":"6bb34914"}[chunkId] + ".chunk.js";
};